export const JobsCardLoadingPlaceholder = () => (
  <div className="border border-[#DFDDDD] rounded-xl shadow-sm animate-pulse">
    <div className="px-4 pt-4 flex justify-between items-start">
      <div className="flex flex-col md:flex-row md:items-center gap-y-5 gap-2.5 mb-6">
        <div className="flex justify-between items-start">
          <div className="w-[50px] h-[50px] rounded-full bg-gray-200"></div>
        </div>
        <div className="flex-1 space-y-4">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="flex gap-2 items-center mt-2">
            <div className="w-1/2 h-3 bg-gray-200 rounded"></div>
            <div className="w-[1.5px] h-3 bg-gray-300"></div>
            <div className="w-1/4 h-3 bg-gray-200 rounded"></div>
            <div className="ml-4 w-1/3 h-3 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <div className="p-4 flex flex-col md:flex-row justify-between items-center border-t-[2.5px] border-[#f6f6f6] gap-y-4">
      <div className="flex flex-wrap justify-between md:justify-normal gap-y-3.5 gap-x-5 items-center">
        <div className="w-[110px] h-3 bg-gray-200 rounded"></div>
        <div className="w-[110px] h-3 bg-gray-200 rounded"></div>
      </div>
      <div className="w-24 h-8 bg-gray-200 rounded"></div>
    </div>
  </div>
);
